import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Patient Components
import PatientDashboard from "../pages/patient/Dashboard";
import Assessment from "../pages/patient/Assessment";
import Profile from "../pages/patient/Profile"
import AssessmentResults from "../pages/patient/AssessmentResults";
// import Diagnosis from "../pages/patient/Diagnosis";
import Layout from "../pages/patient/Layout";
import Sessions from '../pages/patient/Sessions';
// Coming Soon Component
import ComingSoon from "../components/ComingSoon";


const PatientRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<PatientDashboard />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="assessment" element={<Assessment />} />
        <Route path="profile" element={<Profile />} />
        {/* <Route path="diagnosis" element={<Diagnosis />} /> */}
        {/* <Route path="assessment-results" element={<AssessmentResults />} /> */}
        <Route path="assessment-results/:assessmentId" element={<AssessmentResults />} />


        {/* Catch-all route for unimplemented patient pages */}
        <Route
          path="*"
          element={
            <ComingSoon
              title="Coming Soon"
              subtitle="Patient feature under development"
              description="This patient feature is currently being developed. Please check back soon for updates!"
            />
          }
        />
      </Routes>
    </Layout>
  );
};

export default PatientRoutes;
